import { Navigate } from "react-router-dom";
export default function RedireccionarALanding() {
  return <Navigate to="/" />;
}
